import React, { useState } from 'react';
import api from '../services/apiClient';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './SendMessageModal.css';

const SendMessageModal = ({ formName, onClose, showDatePicker = false }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: `I need assistance with ${formName || 'your services'}.`,
    preferredDate: null
  });
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevData => ({
      ...prevData,
      [name]: value
    }));
  };

  const handleDateChange = (date) => {
    setFormData(prevData => ({
      ...prevData,
      preferredDate: date
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError('');

    try {
      // Format the message with the date if selected
      const messageData = {...formData};
      
      if (showDatePicker && messageData.preferredDate) {
        const formattedDate = messageData.preferredDate.toLocaleString('en-US', {
          weekday: 'long',
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        });
        messageData.message = `Preferred date and time: ${formattedDate}\n\n${messageData.message}`;
      }
      
      // Remove the preferredDate field before sending
      delete messageData.preferredDate;
      
      // Use the API client to post to the messages endpoint
      await api.post('/messages/', messageData);
      setSuccess(true);
      setTimeout(() => {
        onClose();
      }, 3000);
    } catch (err) {
      console.error('Error sending message:', err);
      setError('Failed to send message. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <div className="modal-header">
          <h2>{showDatePicker ? 'Book a Call' : 'Send Us a Message'}</h2>
          <button className="modal-close-button" onClick={onClose}>×</button>
        </div>

        {success ? (
          <div className="modal-success">
            <p>Your message has been sent successfully! We'll get back to you soon.</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="message-form">
            <div className="form-group">
              <label htmlFor="name">Name</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                placeholder="Your full name"
              />
            </div>

            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                placeholder="Your email address"
              />
            </div>

            <div className="form-group">
              <label htmlFor="phone">Phone</label>
              <input
                type="tel"
                id="phone"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                placeholder="Your phone number (optional)"
              />
            </div>

            {showDatePicker && (
              <div className="form-group">
                <label htmlFor="preferredDate">Preferred Date & Time</label>
                <DatePicker
                  selected={formData.preferredDate}
                  onChange={handleDateChange}
                  showTimeSelect
                  timeFormat="HH:mm"
                  timeIntervals={30}
                  timeCaption="Time"
                  dateFormat="MMMM d, yyyy h:mm aa"
                  minDate={new Date()}
                  required
                  placeholderText="Select a date and time"
                  className="date-picker-input"
                />
              </div>
            )}

            <div className="form-group">
              <label htmlFor="message">Message</label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                required
                rows="4"
                placeholder="How can we help you?"
              />
            </div>

            {error && <div className="error-message">{error}</div>}

            <button 
              type="submit" 
              className="submit-button" 
              disabled={submitting}
            >
              {submitting ? 'Sending...' : (showDatePicker ? 'Book Call' : 'Send Message')}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default SendMessageModal; 